
import { RolesUsuarioProps } from '../admin/UsuarioInterface';

// Definición de defaults

export const defaultHttpResponse: HttpResponse = {
    success:    false,
    message:    ''
};

export const defaultVersionResponse: VersionResponse = {
    ...defaultHttpResponse,
    version:    ''
};

export const defaultLoginParams: LoginParams = {
    correoElectronico:      '',
    contrasena:             ''
};

// Creación de interfaces 

export interface HttpResponse {
    success:    boolean;
    message:    string;
}

export interface VersionResponse extends HttpResponse {
    version:    string;
}

export interface LoginParams {
    correoElectronico:      string;
    contrasena:             string;
}

export interface LoginResponse extends HttpResponse {
    nombres?:                           string;
    apellidos?:                         string;
    token?:                             string;
    correoElectronico?:                 string;
    administrador?:                     boolean;
    coordinador?:                       boolean;
    restablecerContrasena?:             boolean;
    idUnidad?:                          number;
    unidad?:                            string;
    roles?:                             RolesUsuarioProps;
    requiereVerificacion?:              boolean;
    telefono?:                          string;
}

export interface EnviarCodigoVerificacionParams {
    correoElectronico:      string;
    contrasena:             string;
    idTipoEnvio:            number;
}

export interface ValidarCodigoVerificacionParams {
    correoElectronico:      string;
    contrasena:             string;
    codigo:                 string;
}

export interface EntrarComoParams {
    idUsuario:              number;
}

export interface CambiarContrasenaParams {
    contrasena:             string;
}

export interface ValidarFirmaElectronicaResponse extends HttpResponse {
    firmaElectronica?:                  boolean;
    diasExpiracionFirmaElectronica?:    number;
}